export default __webpack_public_path__ + "static/media/edit-cut.37b5af4a.png";